import { render, staticRenderFns } from "./IconAttach.vue?vue&type=template&id=753374fb&"
import script from "./IconAttach.vue?vue&type=script&lang=js&"
export * from "./IconAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports